/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_CancelInputs */

const en_creator_ext_device_cancel = /** @type {(inputs: Creator_Ext_Device_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, skip`)
};

const fr_creator_ext_device_cancel = /** @type {(inputs: Creator_Ext_Device_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non, ignorer`)
};

const de_creator_ext_device_cancel = /** @type {(inputs: Creator_Ext_Device_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein, überspringen.`)
};

const it_creator_ext_device_cancel = /** @type {(inputs: Creator_Ext_Device_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, salta`)
};

const ru_creator_ext_device_cancel = /** @type {(inputs: Creator_Ext_Device_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет, пропустить`)
};

const es_creator_ext_device_cancel = /** @type {(inputs: Creator_Ext_Device_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, salta`)
};

const zh_cn2_creator_ext_device_cancel = /** @type {(inputs: Creator_Ext_Device_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不，跳过`)
};

const ja_creator_ext_device_cancel = /** @type {(inputs: Creator_Ext_Device_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ、スキップ`)
};

const hi_creator_ext_device_cancel = /** @type {(inputs: Creator_Ext_Device_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं, छोड़ दो`)
};

const pt_pt2_creator_ext_device_cancel = /** @type {(inputs: Creator_Ext_Device_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, pule`)
};

/**
* | output |
* | --- |
* | "No, skip" |
*
* @param {Creator_Ext_Device_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_cancel = /** @type {((inputs?: Creator_Ext_Device_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_ext_device_cancel(inputs)
	if (locale === "de") return de_creator_ext_device_cancel(inputs)
	if (locale === "it") return it_creator_ext_device_cancel(inputs)
	if (locale === "ru") return ru_creator_ext_device_cancel(inputs)
	if (locale === "es") return es_creator_ext_device_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_ext_device_cancel(inputs)
	if (locale === "ja") return ja_creator_ext_device_cancel(inputs)
	if (locale === "hi") return hi_creator_ext_device_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_ext_device_cancel(inputs)
	return en_creator_ext_device_cancel(inputs)
});